module.exports = __webpack_public_path__ + "static/img/reason_head_4.c81559fb.png";